import React, { useCallback, useMemo } from 'react'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import SimulationSetting from './SimutationSetting'
import Text from '../../../atoms/text/Text'
import Dropdown from '../../../atoms/form/input/Dropdown'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import { useSimulations } from '../../../../hooks/useSimulations'

interface Props {
  simulationId?: string
  clientId?: string
  readOnly?: boolean
  state?: string
  onChange?: (simulation: API.SimulationResponse | null) => void
}

interface SelectValue {
  id: string
  value: string
  label: string
  simulation: API.SimulationResponse
}

const SelectSimulation: React.FC<Props> = ({ clientId, simulationId, onChange, readOnly = false, state = 'complete' }) => {
  const onClearSelection = useCallback(() => {
    onChange && onChange(null)
  }, [onChange])

  const onChangeCallback = useCallback((selected: SelectValue) => {
    onChange && onChange(selected.simulation)
  }, [onChange])

  const clientIds = useMemo(() => clientId ? [clientId] : [], [clientId])

  const { data } = useSimulations(clientIds, true, state)

  const options: SelectValue[] = useMemo(() => {
    return data ? data.map(simulation => ({
      id: simulation.id,
      value: simulation.id,
      label: simulation.generalSetup.name,
      simulation,
    })) : []
  }, [data])

  const currentSelected = useMemo(() => {
    if (simulationId) {
      return options.find(option => option.id === simulationId)
    }
    return null
  }, [simulationId, options])

  return <SimulationSetting icon='simulations' onTrashClick={onClearSelection} readOnly={readOnly} warning={readOnly && currentSelected?.simulation.state !== 'complete'}>
    <InlineGroup stretch>
      <VerticalGroup spaceBetweenElements={2}>
        <Text size="sm" bold>Simulation</Text>

        {readOnly && currentSelected &&
          <InlineGroup spaceLeft={2}>
            <Text size="sm">Simulation Selected: </Text>
            <Text size="sm" bold >{currentSelected?.label}</Text>
          </InlineGroup>
        }
        {readOnly && currentSelected?.simulation.state === 'draft' &&
          <InlineGroup spaceLeft={2}>
            <Text size="sm" colour='danger' bold>Selected Simulation is in Draft Mode</Text>
          </InlineGroup>
        }
        {readOnly && !currentSelected &&
          <InlineGroup spaceLeft={2}>
            <Text size="sm" colour='danger' bold>No Simulation Selected</Text>
          </InlineGroup>
        }
        {!readOnly && <Dropdown
          selectProps={{
            isDisabled: !clientId,
            onChange: onChangeCallback,
            value: currentSelected,
            options,
            noOptionsMessage: () => 'No Published Simulations'
          }}
        />}
      </VerticalGroup>
    </InlineGroup>
  </SimulationSetting>
}

export default SelectSimulation
